import React, { useMemo } from "react";
import Slider from "react-slick";
import { motion } from "framer-motion";
import { Typewriter } from "react-simple-typewriter";
import "./OurClientCarousel.css";

import c1 from "../../Images/gallery1.jpg";
import c2 from "../../Images/gallery2.jpg";
import c3 from "../../Images/gallery3.jpg";
import c4 from "../../Images/gallery1.jpg";
import c5 from "../../Images/gallery3.jpg";

const testimonials = [
  {
    id: 1,
    image: c1,
    text: "The attention to detail and commitment to quality is unmatched. Their guidance from inquiry to handover was seamless.",
    name: "Arjun Sharma",
    location: "Mumbai, India",
  },
  {
    id: 2,
    image: c2,
    text: "We found our dream home thanks to their dedicated support and transparency throughout the entire process.",
    name: "Priya & Rohit",
    location: "Kolkata, India",
  },
  {
    id: 3,
    image: c3,
    text: "Professional, trustworthy, and extremely helpful. The entire experience was stress-free and smooth.",
    name: "Sofia Menon",
    location: "Bangalore, India",
  },
  {
    id: 4,
    image: c4,
    text: "Their expertise is remarkable. They truly care about customer satisfaction and deliver beyond expectations.",
    name: "Aman Verma",
    location: "Hyderabad, India",
  },
  {
    id: 5,
    image: c5,
    text: "Highly recommended for property investment. Reliable, responsive and knowledgeable.",
    name: "Karan Patel",
    location: "Pune, India",
  },
];

const TestimonialCarousel = () => {

  const sliderSettings = useMemo(() => ({
    dots: false,
    arrows: testimonials.length > 1,
    infinite: testimonials.length > 1,
    speed: 700,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: testimonials.length > 1,
    autoplaySpeed: 4000,
    pauseOnHover: true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
        },
      },
    ],
  }), []);

  return (
    <section className="testimonial-section">
      <h2 className="testimonial-title">What Our Clients Say</h2>

      <Slider {...sliderSettings} className="testimonial-slider">
        {testimonials.map(({ id, image, text, name, location }) => (
          <motion.div
            key={id}
            className="testimonial-card"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <img src={image} alt={name} className="client-img" />

            <p className="testimonial-text">
              <Typewriter
                words={[text]}
                loop={1}
                cursor={false}
                typeSpeed={35}
                deleteSpeed={15}
                delaySpeed={2000}
              />
            </p>

            <h4 className="client-name">{name}</h4>
            <p className="client-location">{location}</p>
          </motion.div>
        ))}
      </Slider>
    </section>
  );
};

export default TestimonialCarousel;